import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Field } from 'redux-form';
import { CheckboxGroup } from '../../../../common/components/ReduxFormField';
import './Signpost.scss';
import { acceptance } from 'redux-form-validators';
const Signpost = ({ signpost }) => {
  if (!signpost) {
    return null;
  }

  const LinkRenderer = ({ href, children }) => {
    return (
      <a href={href} target="_blank">
        {children}
      </a>
    );
  };

  return (
    <div className={'signpost'}>
      <ReactMarkdown source={signpost} renderers={{ link: LinkRenderer }} />
      <Field
        name={'data.attributes.metadata.signpost_acknowledged'}
        validate={acceptance({
          message: 'Please confirm the signpost text has been read and acknowledged',
        })}
        inline
        options={[
          {
            label: '    I have read to the customer and it has been acknowledged',
            value: true,
          },
        ]}
        component={CheckboxGroup}
      />
    </div>
  );
};
export default Signpost;
